const ADMIN_PANEL = ['admin'];

export default ADMIN_PANEL;
